/* global axios */
// AI F §1.1.5 — knowledge base sources
import ApiClient from './ApiClient';

class KbSourcesAPI extends ApiClient {
  constructor() {
    super('kb_sources', { accountScoped: true });
  }

  list({
    page,
    sort,
    status,
    sourceType,
    updatedFrom,
    updatedTo,
    sizeFrom,
    sizeTo,
  }) {
    const params = Object.entries({
      page,
      sort,
      status: status?.join(','),
      source_type: sourceType?.join(','),
      // AI F §1.1.5 — Last Updated range and Size filters
      updated_from: updatedFrom,
      updated_to: updatedTo,
      size_from: sizeFrom,
      size_to: sizeTo,
    }).reduce(
      (acc, [key, value]) => (value ? { ...acc, [key]: value } : acc),
      {}
    );
    return axios.get(`${this.url}?${this.objectToQueryString(params)}`);
  }

  // AI F §1.1.10 — "Test query"
  search(query) {
    return axios.post(`${this.url}/search`, { query });
  }

  // AI F §1.2.2 — multipart upload of one file
  upload(formData) {
    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  // AI F §1.2.5
  reindex(id) {
    return axios.post(`${this.url}/${id}/reindex`);
  }

  // AI F §1.1.2, §1.2.3 — extract the stored original again
  reextract(id) {
    return axios.post(`${this.url}/${id}/reextract`);
  }

  // AI F §1.1.8 — archiving is the inherited delete(id)
  restore(id) {
    return axios.post(`${this.url}/${id}/restore`);
  }
}

export default new KbSourcesAPI();
